export const WORKSPACE_ID = 'Workspace';
